/**
 * FAQ Icons Catalog
 * Synchronized with .NET MAUI ResourceDictionary (IconFont2Code PascalCase keys)
 * and Material Design Icons (@mdi/font classes for Backoffice Web UI).
 */

export const DEFAULT_FAQ_ICON_KEY = 'HelpCircleOutline';

export const FAQ_ICONS = [
  {
    key: 'HelpCircleOutline',
    mdi: 'mdi-help-circle-outline',
    label: 'Ayuda General / Preguntas',
    category: 'General',
  },
  {
    key: 'ClockOutline',
    mdi: 'mdi-clock-outline',
    label: 'Horarios / Tiempos de Entrega',
    category: 'Entregas',
  },
  {
    key: 'TruckDelivery',
    mdi: 'mdi-truck-delivery',
    label: 'Despachos / Envíos',
    category: 'Entregas',
  },
  {
    key: 'TruckFast',
    mdi: 'mdi-truck-fast',
    label: 'Envíos Rápidos / Urgentes',
    category: 'Entregas',
  },
  {
    key: 'MapMarkerRadiusOutline',
    mdi: 'mdi-map-marker-radius-outline',
    label: 'Zonas / Cobertura de Ruta',
    category: 'Entregas',
  },
  {
    key: 'CashMultiple',
    mdi: 'mdi-cash-multiple',
    label: 'Efectivo / Moneda / Divisas',
    category: 'Pagos',
  },
  {
    key: 'CellphoneCheck',
    mdi: 'mdi-cellphone-check',
    label: 'Pago Móvil / Validación',
    category: 'Pagos',
  },
  {
    key: 'CreditCardOutline',
    mdi: 'mdi-credit-card-outline',
    label: 'Tarjetas / Débito / Crédito',
    category: 'Pagos',
  },
  {
    key: 'BankOutline',
    mdi: 'mdi-bank-outline',
    label: 'Transferencias Bancarias',
    category: 'Pagos',
  },
  {
    key: 'ReceiptTextOutline',
    mdi: 'mdi-receipt-text-outline',
    label: 'Facturación / Comprobantes',
    category: 'Pagos',
  },
  {
    key: 'FileDocumentOutline',
    mdi: 'mdi-file-document-outline',
    label: 'Documentos / RIF / Legal',
    category: 'Cuenta',
  },
  {
    key: 'ShieldCheckOutline',
    mdi: 'mdi-shield-check-outline',
    label: 'Seguridad / Garantías / Verificación',
    category: 'Cuenta',
  },
  {
    key: 'AccountCircleOutline',
    mdi: 'mdi-account-circle-outline',
    label: 'Cuenta / Perfil Comercial',
    category: 'Cuenta',
  },
  {
    key: 'StoreOutline',
    mdi: 'mdi-store-outline',
    label: 'Comercios / Puntos de Venta',
    category: 'Cuenta',
  },
  {
    key: 'CartOutline',
    mdi: 'mdi-cart-outline',
    label: 'Pedidos / Carrito de Compras',
    category: 'Pedidos',
  },
  {
    key: 'PackageVariantClosed',
    mdi: 'mdi-package-variant-closed',
    label: 'Productos / Empaques / Bultos',
    category: 'Pedidos',
  },
  {
    key: 'Refresh',
    mdi: 'mdi-refresh',
    label: 'Repetir Pedido / Reabastecimiento',
    category: 'Pedidos',
  },
  {
    key: 'TagOutline',
    mdi: 'mdi-tag-outline',
    label: 'Precios / Descuentos / Promociones',
    category: 'Pedidos',
  },
  {
    key: 'CalendarClock',
    mdi: 'mdi-calendar-clock',
    label: 'Días de Despacho / Cronogramas',
    category: 'Entregas',
  },
  {
    key: 'PhoneInTalkOutline',
    mdi: 'mdi-phone-in-talk-outline',
    label: 'Atención Telefónica / Soporte',
    category: 'General',
  },
  {
    key: 'BellRingOutline',
    mdi: 'mdi-bell-ring-outline',
    label: 'Notificaciones / Avisos',
    category: 'General',
  },
  {
    key: 'AlertCircleOutline',
    mdi: 'mdi-alert-circle-outline',
    label: 'Reclamos / Devoluciones / Alertas',
    category: 'General',
  },
  {
    key: 'InformationOutline',
    mdi: 'mdi-information-outline',
    label: 'Información Institucional',
    category: 'General',
  },
  {
    key: 'CheckDecagramOutline',
    mdi: 'mdi-check-decagram-outline',
    label: 'Calidad / Certificación Comercial',
    category: 'General',
  },
];

/**
 * Returns metadata for a given icon key or legacy kebab-case MDI string.
 * Ensures an icon object is always returned with valid fallback.
 */
export const getFaqIconMeta = (iconKeyOrMdi) => {
  if (!iconKeyOrMdi) return FAQ_ICONS[0];

  // Try direct key match (PascalCase)
  let found = FAQ_ICONS.find((i) => i.key === iconKeyOrMdi);
  if (found) return found;

  // Try case-insensitive or kebab match
  const normalizedSearch = iconKeyOrMdi.toLowerCase().replace(/[^a-z0-9]/g, '');
  found = FAQ_ICONS.find(
    (i) => i.key.toLowerCase().replace(/[^a-z0-9]/g, '') === normalizedSearch ||
           i.mdi.toLowerCase().replace(/[^a-z0-9]/g, '') === normalizedSearch
  );
  if (found) return found;

  // Dynamic fallback
  const isMdi = iconKeyOrMdi.startsWith('mdi-');
  return {
    key: iconKeyOrMdi,
    mdi: isMdi ? iconKeyOrMdi : `mdi-${iconKeyOrMdi.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()}`,
    label: iconKeyOrMdi,
    category: 'General',
  };
};
